import React from "react";
import styled from "styled-components";
import { device } from "../../../WSUtils/constants/mediaQueries";

export const MessageInfo: React.FC = ({}) => {
  return (
    <StyledMessageInfo className="cvp-messageInfo">
      {infoData.map((data) => {
        const { title, info } = data;

        return (
          <>
            <div key={title}>{title}</div>
            <div key={info}>{info}</div>
          </>
        );
      })}
    </StyledMessageInfo>
  );
};

export const StyledMessageInfo = styled.div`
  &.cvp-messageInfo {
    display: grid;
    grid-template-columns: fit-content(1000px) auto;
    grid-auto-flow: row;
    grid-template-rows: auto auto;
    grid-auto-rows: auto;
    grid-gap: 10px;

    div {
      display: grid;
      align-items: center;
    }
  }

  @media ${device} {
  }
`;

export const infoData = [
  {
    title: "Dato",
    info: "18.11.2022 13:00",
  },
  {
    title: "Til",
    info: "Bemanningsentralen",
  },
  {
    title: "Fra",
    info: "Navn Navesen",
  },
  {
    title: "Emne",
    info: "Timelister",
  },
];
